import { Component } from "react"
import {
    Button,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    UncontrolledDropdown
} from 'reactstrap'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import cfg from "../../../utils/config"
import auth from "../../../utils/auth"
import helper from "../../../utils/helper"
import axios from "axios"
import ConfirmDelete from "../../../components/ConfirmDelete"
import Table from "../../../components/Table"

class TemplateParametrizacao extends Component {
    userInfo = auth.getUserInfo()
    configMe = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }
    baseUrl = cfg.base_api_url + cfg.api_v2

    tableRef = null
    tableGlobalRef = null

    state = {
        detalhes: { descricao: "", template: "" },
        modal: { importar: false, exportar: false, salvar: false },
        jsonData: { importar: "", exportar: "" },
        tableParametros: [],
        countParametros: 0,
        nextParametros: null,
        previousParametros: null,
        loadingParametros: false,
        selected: [],
        tableGlobal: [],
        countGlobal: 0,
        nextGlobal: null,
        previousGlobal: null,
        loadingGlobal: false,
        selectGlobal: [],
    }

    componentDidMount() {
        this.getTemplates()
    }

    fetchParametros = ({ lineCount = 10, filter = "", url = null } = {}) => {
        this.setState({ loadingParametros: true })

        const endpoint = url
            ?? `${this.baseUrl}/${this.userInfo.empresa}/parametrizacao-template/?limit=${lineCount}${filter}`

        axios.get(endpoint, this.configMe).then((res) => {
            this.setState({
                tableParametros: res.data?.results ?? [],
                countParametros: res.data?.count ?? 0,
                nextParametros: res.data?.next ?? null,
                previousParametros: res.data?.previous ?? null,
                loadingParametros: false,
            })
        }).catch(() => this.setState({ loadingParametros: false }))
    }

    fetchGlobal = ({ lineCount = 10, filter = "", url = null } = {}) => {
        this.setState({ loadingGlobal: true })

        const endpoint = url
            ?? `${this.baseUrl}/${this.userInfo.empresa}/parametrizacao-template/global/?limit=${lineCount}${filter}`

        axios.get(endpoint, this.configMe).then((res) => {
            this.setState({
                tableGlobal: res.data?.results ?? [],
                countGlobal: res.data?.count ?? 0,
                nextGlobal: res.data?.next ?? null,
                previousGlobal: res.data?.previous ?? null,
                loadingGlobal: false,
            })
        }).catch(() => this.setState({ loadingGlobal: false }))
    }

    getTemplates = () => {
        if (this.props.parametrizacoes.length > 0) {
            let { jsonData } = this.state
            jsonData["exportar"] = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(this.props.parametrizacoes))
            this.setState({ jsonData })
        }

        this.fetchParametros()
        this.fetchGlobal()
    }

    handleModal = (state) => {
        let { modal } = this.state
        modal[state] = !modal[state]
        this.setState({ modal })
    }

    handleChange = (e) => {
        let { detalhes } = this.state
        detalhes[e.target.name] = e.target.value
        this.setState({ detalhes })
    }

    toggleRow = (e, id, tipo = "nuvem") => {
        if (tipo === "global") {
            this.setState({ selectGlobal: e.target.checked ? [id] : [] })
        } else {
            this.setState({ selected: e.target.checked ? [id] : [] })
        }
    }

    saveTemplate = () => {
        const { parametrizacoes } = this.props
        const { detalhes } = this.state

        if (parametrizacoes?.length > 0) {
            if (!detalhes.descricao) return

            const body = new FormData()
            body.append("descricao", detalhes.descricao)
            body.append("template", JSON.stringify(parametrizacoes))

            axios({
                method: "POST",
                url: `${this.baseUrl}/${this.userInfo.empresa}/parametrizacao-template/`,
                data: body,
                ...this.configMe
            }).then(() => {
                let { detalhes } = this.state
                detalhes.descricao = ""
                this.setState({ detalhes })
                this.handleModal("salvar")
                helper.dispatchEvent("showAviso", { message: "Template cadastrado com sucesso" })
            })
        }
    }

    importar = async () => {
        let { detalhes, jsonData, selected, selectGlobal } = this.state
        const parametros = []

        const pushParametro = (parametro) => {
            parametros.push({
                descricao: parametro.descricao,
                formula: parametro.formula,
                unidade: parametro.unidade,
                identificacao: parametro.identificacao,
                mascara: parametro.mascara,
                decimal: parametro.decimal,
                operador_especial: parametro.operador_especial,
                prioridade: parametro.prioridade,
                tipo_dado_saida: parametro.tipo_dado_saida,
                tipo_grafico: parametro.tipo_grafico,
                icone: parametro.icone,
                configuracao: parametro.configuracao
            })
        }

        if (selected.length === 1) {
            const parametros_template = this.state.tableParametros.find(t => t.id === selected[0])?.template
            parametros_template?.forEach(p => pushParametro(p))
            this.renderToImport(parametros)
        } else if (selectGlobal.length === 1) {
            const parametros_template = this.state.tableGlobal.find(t => t.id === selectGlobal[0])?.template
            parametros_template?.forEach(p => pushParametro(p))
            this.renderToImport(parametros)
        } else if (jsonData.importar) {
            const reader = new FileReader()
            reader.onload = async (e) => {
                try {
                    const parametros_json = JSON.parse(e.target.result)
                    parametros_json.forEach(p => pushParametro(p))
                    this.renderToImport(parametros)
                } catch (err) {
                    helper.dispatchEvent("showAviso", { message: "Erro ao processar arquivo!" })
                }
            }
            reader.readAsText(jsonData.importar)
        }

        detalhes.template = ""
        jsonData.importar = ""
        this.setState({ detalhes, jsonData, selected: [], selectGlobal: [] })
        this.handleModal("importar")
    }

    renderToImport = (parametros) => {
        this.props.subirParametrosImportados(parametros)
    }

    close = () => {
        let { detalhes, jsonData } = this.state
        detalhes.template = ""
        jsonData.importar = ""
        this.setState({ detalhes, selected: [], selectGlobal: [] })
        this.handleModal("importar")
    }

    removeTemplate = (id) => {
        axios.delete(`${this.baseUrl}/${this.userInfo.empresa}/parametrizacao-template/${id}/`, this.configMe).then(() => {
            this.fetchParametros()
            this.props?.getData()
        })
    }

    getColumnsParametros = () => [
        {
            Header: "",
            Accessor: "checkbox_pessoal",
            sortable: false,
            Cell: (row) => (
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <input
                        type="checkbox"
                        checked={this.state.selected?.includes(row.id)}
                        onChange={(e) => this.toggleRow(e, row.id)}
                    />
                </div>
            )
        },
        {
            Header: "Descrição",
            Accessor: "descricao",
        },
        {
            Header: "Parâmetros",
            Accessor: "template_count",
            sortable: false,
            Cell: (row) => row.template?.length ?? 0,
        },
        {
            Header: "",
            Accessor: "acoes",
            sortable: false,
            Cell: (row) => (
                <div style={{ textAlign: "center" }} className="clean-action">
                    <ConfirmDelete
                        enabled={true}
                        action={() => this.removeTemplate(row.id)}
                        label="Remover"
                    />
                </div>
            )
        }
    ]

    getColumnsGlobal = () => [
        {
            Header: "",
            Accessor: "checkbox_global",
            sortable: false,
            Cell: (row) => (
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <input
                        type="checkbox"
                        checked={this.state.selectGlobal?.includes(row.id)}
                        onChange={(e) => this.toggleRow(e, row.id, "global")}
                    />
                </div>
            )
        },
        {
            Header: "Descrição",
            Accessor: "descricao",
        },
        {
            Header: "Parâmetros",
            Accessor: "template_count",
            sortable: false,
            Cell: (row) => row.template?.length ?? 0,
        }
    ]

    render() {
        const { modal, jsonData, detalhes } = this.state

        return (
            <>
                <Modal isOpen={modal.importar} toggle={() => this.handleModal("importar")} className="modal-md modal-lg" data-tour="param-import-modal-wrap">
                    <ModalHeader toggle={() => this.handleModal("importar")}>Importar Parâmetros</ModalHeader>
                    <ModalBody style={{ minHeight: "380px" }} className="p-1 px-3 template-import-modal" data-tour="param-import-modal">
                        <Tabs>
                            <TabList data-tour="param-import-tabs">
                                <Tab>Pessoal</Tab>
                                <Tab>Global</Tab>
                                <Tab>Arquivo Local</Tab>
                            </TabList>
                            <TabPanel>
                                <Table
                                    notEditFirstColum
                                    checkbox={false}
                                    config={false}
                                    data={this.state.tableParametros}
                                    columns={this.getColumnsParametros()}
                                    count={this.state.countParametros}
                                    next={this.state.nextParametros}
                                    previous={this.state.previousParametros}
                                    loading={this.state.loadingParametros}
                                    onFetchData={this.fetchParametros}
                                    onUpdate={(ref) => { this.tableRef = ref }}
                                />
                            </TabPanel>
                            <TabPanel data-tour="param-import-checkbox-area">
                                <Table
                                    notEditFirstColum
                                    checkbox={false}
                                    config={false}
                                    data={this.state.tableGlobal}
                                    columns={this.getColumnsGlobal()}
                                    count={this.state.countGlobal}
                                    next={this.state.nextGlobal}
                                    previous={this.state.previousGlobal}
                                    loading={this.state.loadingGlobal}
                                    onFetchData={this.fetchGlobal}
                                    onUpdate={(ref) => { this.tableGlobalRef = ref }}
                                />
                            </TabPanel>
                            <TabPanel>
                                <div className="hdv-file-picker" style={{ width: "fit-content", textAlign: "center", margin: "20px auto" }}>
                                    <label>Arquivo (Formato JSON)</label>
                                    <br />
                                    <input
                                        type="file"
                                        accept=".json"
                                        name="json-file"
                                        id="json-file"
                                        value={jsonData.importar?.path ?? ""}
                                        onChange={(e) => {
                                            let { jsonData } = this.state
                                            jsonData["importar"] = e.target.files[0]
                                            this.setState({ jsonData })
                                        }}
                                    />
                                    <label style={{ width: "320px" }} htmlFor="json-file">
                                        {jsonData.importar?.name ?? "Selecionar arquivo"}
                                    </label>
                                </div>
                            </TabPanel>
                        </Tabs>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="default" data-tour="param-import-fechar" onClick={this.close}>Fechar</Button>
                        <Button color="primary" data-tour="param-import-confirmar" onClick={this.importar}>Importar</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={modal.salvar} toggle={() => this.handleModal("salvar")}>
                    <ModalHeader toggle={() => this.handleModal("salvar")}>Salvar Parametrizações</ModalHeader>
                    <ModalBody>
                        <div className="row">
                            <div className="col-md-12">
                                <label className="required" htmlFor="descricao">Descrição do template</label>
                                <input type="text" name="descricao" id="descricao" value={detalhes.descricao} onChange={this.handleChange} />
                                <span id="validacao-descricao"></span>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="default" onClick={() => this.handleModal("salvar")}>Fechar</Button>
                        <Button color="success" onClick={this.saveTemplate}>Salvar</Button>
                    </ModalFooter>
                </Modal>

                <UncontrolledDropdown direction="right" className="float-right">
                    <DropdownToggle nav>
                        <div className="device-export-options" data-tour="param-options">
                            <i className="fa fa-bars" style={{ fontSize: "23px" }}></i>
                            <span>Opções</span>
                        </div>
                    </DropdownToggle>
                    <DropdownMenu className="mini-modal dropdown-menu dropdown-menu-right dropdown-params">
                        {this.props.parametrizacoes.length > 0 && (
                            <DropdownItem className="dropdown-item" onClick={() => this.handleModal("salvar")}>
                                <i className="fa fa-save"></i> Salvar
                            </DropdownItem>
                        )}
                        <DropdownItem
                            data-tour="param-importar"
                            onClick={() => { this.handleModal("importar"); this.getTemplates() }}
                            disabled={!this.props.allowNewParam}
                        >
                            <i className="fa fa-cloud-upload-alt"></i> Importar Parâmetros
                        </DropdownItem>
                        {this.props.parametrizacoes.length > 0 && (
                            <a href={jsonData.exportar ?? "#"} download={`parametros_${this.props.detalhes.id ?? "0"}.json`}>
                                <DropdownItem>
                                    <i className="fa fa-cloud-download-alt"></i> Exportar Parâmetros
                                </DropdownItem>
                            </a>
                        )}
                    </DropdownMenu>
                </UncontrolledDropdown>
            </>
        )
    }
}

export default TemplateParametrizacao